<ng-container *ngIf="dependencyCount && dependencyCount > 0">
  <div class="task-tabs" [ngStyle]="{'flex': flexDeep}"></div>
  <div class="task-dependency">
    <mat-icon
      class="dependency-icon tooltip"
      matTooltip="{{dependentOn}}"
      [matTooltipShowDelay]="showDelay.value"
      [matTooltipHideDelay]="hideDelay.value"
      *ngIf="dependentOn"
      >subdirectory_arrow_left</mat-icon
    >
    <mat-icon class="dependency-icon" *ngIf="!dependentOn">subdirectory_arrow_left</mat-icon>
  </div>
</ng-container>

<div class="task-content">
  <ng-content></ng-content>
</div>
